import { render, staticRenderFns } from "./LogotypeForm.vue?vue&type=template&id=5bb551be&"
import script from "./LogotypeForm.js?vue&type=script&lang=js&"
export * from "./LogotypeForm.js?vue&type=script&lang=js&"
import style0 from "./LogotypeForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports